export default "__VITE_ASSET__46dee893__"